<template>

    <v-modal title="Sync Segments">
        <template #body>
            <v-alert :message="error" />
            <p>In order for users to enter and exit segments, your segment rules are processed hourly to sync them. You can manually trigger a sync on all your segments right now, and they will be queued to be synced.</p>
            <p>Note: Before sending broadcasts, your segments are synced automatically.</p>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="syncSegments">Sync Segments</v-button>
        </template>
    </v-modal>

</template>

<script>

import ProjectApi from '@api/ProjectApi'

export default {

    data() {
        return {
            loading: false,
            error: null,
        }
    },

    methods: {

        syncSegments() {
            this.loading = true;
            ProjectApi.syncSegments(this.project.id)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.queued'));
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
